import React from 'react';
import Container from 'react-bootstrap/Container'
import HashLoader from 'react-spinners/HashLoader';

import './PageLoadingSpinner.css';

type PageLoadingSpinnerProps = {
  /** The label to display under the spinner. */
  label?: string | null;
};

/**
 * A full-page loading spinner with an optional label.
 */
const PageLoadingSpinner = ({label = null}: PageLoadingSpinnerProps) => {
  const ariaLabel = label ?? 'Loading...';

  return (
    <Container className="text-center">
      <div className="page-loading-div" aria-label={ariaLabel}>
        <HashLoader color='#007bff' loading={true} size={150} />
        {label && <div className="page-loading-label">{label}</div>}
      </div>
    </Container>
  );
};

export default PageLoadingSpinner;